// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"Layout_stickyWrapper__iOoJ9"};